import React from 'react';
import cn from 'classnames';

import { Typography } from 'components/shared/Typography';

import { idxMap } from 'helpers/styleMapIdx';

import { getInitials, generateAvatarColor } from './Avatar.helpers';

import styles from './Avatar.module.scss';

const SIZES = {
  lg: styles.lg,
  md: styles.md,
  sm: styles.sm,
};

const Avatar = ({
  className,
  size,
  url,
  text,
  presenceStatus,
  onClick,
}: {
  className: any;
  size: any;
  url: any;
  text: any;
  presenceStatus?: 'online' | 'offline' | null;
  onClick: any;
}) => (
  <div className={cn(styles.wrapper, className)}>
    <div
      className={cn(styles.avatar, idxMap(SIZES as Record<string, string>, size))}
      style={{
        backgroundColor: generateAvatarColor(text, true),
      }}
      onClick={onClick}
    >
      {url && <img src={url} className={styles.preview} alt="" />}
      {text && !url && (
        <Typography className={styles.text} weight="semiBold">
          {getInitials(text)}
        </Typography>
      )}
    </div>
    {presenceStatus && (
      <span
        className={cn(
          styles.presenceDot,
          idxMap(SIZES as Record<string, string>, size),
          presenceStatus === 'online'
            ? styles.presenceOnline
            : styles.presenceOffline,
        )}
        aria-hidden
      />
    )}
  </div>
);

Avatar.defaultProps = {
  size: 'lg',
};

export default React.memo(Avatar) as any;
